import React from 'react';
import Description from './Description';
import Diptych from './Diptych';

import * as classes from './Wrapper.module.css';

const Wrapper = (props) =>{
    let style = {};

    //style them off page if not active to prevent flash on switch
    if (props.active){
        style = {zIndex: 1}
    }else style = {zIndex: -1, position: 'fixed', visibility: 'hidden'};

    return (
        <div
            className={classes.Wrapper}
            style={style}
        >
            <Diptych 
                caramel={props.caramel} 
                ingredient={props.ingredient} />
            <Description 
                caramel={props.caramel}
                ingredient={props.ingredient} />
        </div>
    )
};

export default Wrapper;